import {
  FEATURE_SEARCH_API_OFF,
  FEATURE_SEARCH_API,
} from './../../modules/featureToggle/index';
import { types, type Instance } from 'mobx-state-tree';
import { getFeaturesEnabledByUrl } from '../../modules/featureToggle/isFeatureEnabled';
import { DEV_EXPERIENCE } from '../../utils/features';

const FeatureStore = types
  .model('FeatureStore', {
    featuresEnabled: types.array(types.string),
    searchApi: types.optional(types.boolean, false),
    matchedQualities: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setSearchApiEnabled() {
      self.searchApi = true;
    },
  }))
  .views((self) => ({
    get isSearchApiFeatureEnabled() {
      const features = getFeaturesEnabledByUrl();
      if (features.includes(FEATURE_SEARCH_API_OFF)) {
        return false;
      }

      return self.searchApi || features.includes(FEATURE_SEARCH_API);
    },

    get isDevExperienceToggleFeatureEnabled() {
      return self.featuresEnabled.includes(DEV_EXPERIENCE);
    },

    get graphClientFeatures() {
      let features = getFeaturesEnabledByUrl();

      if (this.isSearchApiFeatureEnabled) {
        if (!features.includes(FEATURE_SEARCH_API)) {
          features.push(FEATURE_SEARCH_API);
        }
      } else {
        features = features.filter((feature) => feature !== FEATURE_SEARCH_API);
      }

      return features;
    },
  }));

export interface IFeatureStore extends Instance<typeof FeatureStore> {}
export default FeatureStore;
